import React, { useEffect, useState } from "react";
import ProductCard from "../../components/common/ProductCard";
import { productService } from "../../services/product.service";

/**
 * Featured Products Section
 * Fetches products marked with `display_flags = featured`
 * and renders them using the reusable ProductCard component.
 */
const FeaturedProducts = ({ 
  onNavigate, 
  onAddToCart,
  // NEW: Accept the cart props
  cartItems,
  onQuantityChange,
  onRemoveItem,
  favouriteItems
}) => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        // 🔥 Single endpoint, flag-based fetch
        const data = await productService.getByDisplayFlag("featured");
        setProducts(data);
        console.log(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load featured products");
      }
    };

    fetchFeaturedProducts();
  }, []);

  if (error) {
    return <p className="error-text">{error}</p>;
  }

  return (
    <section className="page-section bg-light section-reveal">
      <h2 className="section-title">Our Featured Products</h2>

      <div className="product-grid">
        {products.map((product) => (
          <ProductCard
            key={product._id}
            product={product}
            productId={product.product_id}
            onNavigate={onNavigate}
            onAddToCart={onAddToCart}
            
            // NEW: Pass the props down to the card
            cartItems={cartItems}
            onQuantityChange={onQuantityChange}
            onRemoveItem={onRemoveItem}
            favouriteItems={favouriteItems}
          />
        ))}
      </div>
    </section>
  );
};

export default FeaturedProducts;